export default "__VITE_ASSET__Av6T4oNr__"